var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOperationManage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.953 1.008a.46.46 0 00-.46.46v6.55c0 .253.206.46.46.46h6.549a.46.46 0 00.46-.46 7.017 7.017 0 00-7.01-7.01h0zm.46 6.55V1.945a6.098 6.098 0 015.611 5.611H9.413z",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.506 9.943a.461.461 0 00-.55.348c-.617 2.753-3.115 4.75-5.939 4.75A6.096 6.096 0 011.93 8.954c0-2.824 1.997-5.322 4.75-5.94a.46.46 0 10-.202-.897c-3.168.71-5.469 3.586-5.469 6.837a7.017 7.017 0 007.01 7.009c3.25 0 6.125-2.3 6.836-5.47a.46.46 0 00-.348-.549z",
    strokeWidth: 0.5
  }))));
}
export default SvgOperationManage;